/**
 * Centralized status badge color classes for light/dark mode.
 * Uses Tailwind dark: prefixes so colors auto-switch with .dark class.
 * Status icons using lucide-react should use stroke-current to inherit text color.
 */

export const STATUS_BADGE_CLASSES = {
  success: 'bg-emerald-100 text-emerald-700 border border-emerald-200 dark:bg-emerald-500/20 dark:text-emerald-400 dark:border-emerald-500/30',
  warning: 'bg-amber-100 text-amber-700 border border-amber-200 dark:bg-amber-500/20 dark:text-amber-400 dark:border-amber-500/30',
  danger: 'bg-red-100 text-red-700 border border-red-200 dark:bg-red-500/20 dark:text-red-400 dark:border-red-500/30',
  info: 'bg-blue-100 text-blue-700 border border-blue-200 dark:bg-blue-500/20 dark:text-blue-400 dark:border-blue-500/30',
  purple: 'bg-purple-100 text-purple-700 border border-purple-200 dark:bg-purple-500/20 dark:text-purple-400 dark:border-purple-500/30',
  cyan: 'bg-cyan-100 text-cyan-700 border border-cyan-200 dark:bg-cyan-500/20 dark:text-cyan-400 dark:border-cyan-500/30',
  neutral: 'bg-zinc-100 text-zinc-600 border border-zinc-200 dark:bg-zinc-700 dark:text-zinc-300 dark:border-zinc-600',
  brand: 'bg-amber-50 text-amber-600 border border-amber-200 dark:bg-brand-accent/20 dark:text-brand-accent dark:border-brand-accent/30',
  green: 'bg-green-100 text-green-700 border border-green-200 dark:bg-green-500/20 dark:text-green-400 dark:border-green-500/30',
  orange: 'bg-orange-100 text-orange-700 border border-orange-200 dark:bg-orange-500/20 dark:text-orange-400 dark:border-orange-500/30',
  violet: 'bg-violet-100 text-violet-700 border border-violet-200 dark:bg-violet-500/20 dark:text-violet-400 dark:border-violet-500/30',
};

export const LOAD_STATUS_MAP = {
  draft: 'neutral',
  posted: 'info',
  assigned: 'purple',
  at_pickup: 'brand',
  in_transit: 'cyan',
  at_delivery: 'warning',
  completed: 'success',
  invoiced: 'green',
  cancelled: 'danger',
};

export const DOCUMENT_STATUS_MAP = {
  approved: 'success',
  pending: 'warning',
  rejected: 'danger',
};

export const INVOICE_STATUS_MAP = {
  paid: 'success',
  sent: 'warning',
  overdue: 'danger',
  draft: 'neutral',
};

export const DELIVERY_TYPE_MAP = {
  regular: 'info',
  rush: 'orange',
  direct: 'purple',
};

export function getStatusClasses(status, map = LOAD_STATUS_MAP) {
  const semantic = map[status?.toLowerCase?.()] || 'neutral';
  return STATUS_BADGE_CLASSES[semantic] || STATUS_BADGE_CLASSES.neutral;
}

export function getLoadStatusClasses(status) {
  return getStatusClasses(status, LOAD_STATUS_MAP);
}

export function getDocumentStatusClasses(status) {
  return getStatusClasses(status, DOCUMENT_STATUS_MAP);
}

export function getInvoiceStatusClasses(status) {
  return getStatusClasses(status, INVOICE_STATUS_MAP);
}

export function getDeliveryTypeClasses(type) {
  return getStatusClasses(type, DELIVERY_TYPE_MAP);
}
